import {
  computed,
  reactive,
} from '@vue/composition-api';
import { useZipperApi } from './useZipperApi';

export const useZipperRevenue = () => {
  const { client } = useZipperApi();

  const state = reactive({
    /**
     * @type {any[]}
     */
    revenue: [],
    loading: true,
    error: {
      load: null,
    },
  });

  /**
   * @param {string} customerId
   * @param {import("@sejazipper/layer-api-client").CampaignFilters} filters
   */
  const load = async (customerId, filters) => {
    try {
      state.loading = true;
      state.revenue = await client.chain.query
        .campaignsZipperRevenue({ customerId, filters })
        .get({ date: true, total: true, conversions: true });
    } catch (e) {
      state.error.load = e;
    } finally {
      state.loading = false;
    }
  };

  return {
    load,
    revenue: computed(() => state.revenue),
    loading: computed(() => state.loading),
    error: computed(() => state.error),
  };
};
